/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { deDupeAsync$Json } from '../fn/de-dupe/de-dupe-async-json';
import { DeDupeAsync$Json$Params } from '../fn/de-dupe/de-dupe-async-json';
import { deDupeAsync$Plain } from '../fn/de-dupe/de-dupe-async-plain';
import { DeDupeAsync$Plain$Params } from '../fn/de-dupe/de-dupe-async-plain';

@Injectable({ providedIn: 'root' })
export class DeDupeService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `deDupeAsync()` */
  static readonly DeDupeAsyncPath = '/userops/dedupe/{companyGuid}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deDupeAsync$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  deDupeAsync$Plain$Response(params: DeDupeAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return deDupeAsync$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deDupeAsync$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deDupeAsync$Plain(params: DeDupeAsync$Plain$Params, context?: HttpContext): Observable<string> {
    return this.deDupeAsync$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deDupeAsync$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  deDupeAsync$Json$Response(params: DeDupeAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return deDupeAsync$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deDupeAsync$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deDupeAsync$Json(params: DeDupeAsync$Json$Params, context?: HttpContext): Observable<string> {
    return this.deDupeAsync$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

}
